import { IStory } from "~/types/types";
import getYoutubeThumbnail from "~/lib/utils/getYoutubeThumbnail";

export default function getCoverUrl(story: Pick<IStory, "medias" | "verticalCover">): string | null {
  if (Array.isArray(story.medias) && story.medias.length > 0) {
    const media = story.medias[0];

    if (media) {
      if (media.type === "YOUTUBE") {
        return getYoutubeThumbnail(media.url);
      } else if (media.type === "IMAGE") {
        return media.url;
      }
    }
  }

  if (story.verticalCover) {
    const imageUrl = encodeURIComponent(story.verticalCover);
    return `https://imaginary-ssl.govlaunch.com/smartcrop?height=438&width=876&gravity=smart&url=${imageUrl}`;
  }

  return null;
}
